import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Col, Placeholder } from "rsuite";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faPen,
  faTimes,
  faUndo, faCog, faFileExcel
} from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import { Link } from "react-router-dom";
import styled1 from "styled-components";

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;



const StyledCell1 = styled1.div`
  &.low {
    background: green !important;
  }
  &.medium {
    background: orange;
  }
  &.high {
    background: red !important;
  }
`;

const StyledCell = ({ }) => (
  <b></b>
)

const FilterComponent = ({ filterText, onFilter, onClear, prm, handleGrid, DownloadFile, columnsList }) => (
  <>

    {/* <button onClick={handleGrid}><FontAwesomeIcon icon={faCog} /></button> */}

    {/* <a href={apiUrl.apiUrl.url+'/lease-report/generate-summary-report?'+prm}> */}
    <button type="button" onClick={DownloadFile} className="download_button">
      Download
    </button>
    {/* </a> */}
  </>
);

//const RevenueTable = ({asset, brand, formConfig, expiry_report , expiry_lockin_report, fetchUrl, }) => {
const RevenueTable = ({ asset, brand, formConfig, expiry_report, expiry_lockin_report, fetchUrl, showExport }) => {

  if (typeof formConfig == "undefined") {
    formConfig = {
      'page': 0, 'per_page': 10
    };
  }

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [columns, setColumns] = useState([]);
  const [keyCounter, setkeyCounter] = useState(0);

  React.useEffect(() => {
    fetchLeaseData(1);
  }, [filterText]);

  const conditionalRowStyles = [
    {
      when: row => row.toggleSelected,
      style: {
        backgroundColor: "green",
        userSelect: "none"
      }
    }
  ];
  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };


    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
        prm={prm}
        fetchUrl={fetchUrl}
        showExport={showExport}
        DownloadFile={DownloadFile}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const fetchLeaseData = async (page) => {


    let pageCnt = page ? page : 0;
    formConfig["page"] = pageCnt;
    formConfig["per_page"] = perPage;

    if (typeof expiry_report != "undefined" && expiry_report == "true") {
      formConfig['expiry_report'] = 'true';
    }

    if (typeof expiry_lockin_report != "undefined" && expiry_lockin_report == "true") {
      formConfig['expiry_lockin_report'] = 'true';
    }

    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    console.log(prm, "prm");


    setLoading(true);
    //asset=${asset}&brand=${brand}&page=${page}&per_page=${perPage}&delay=1&term=${filterText}`
    const response = await axios.get(
      `${fetchUrl}` + prm
    );

    if (typeof response.data.data != "undefined" && response.data.data.length > 0) {

      const updatedData = response.data.data.map(item => {
        if (item.srNo !== item.srNo) {
          return item;
        }

        //item.assetName = eval("<b>"+item.assetName+"</b>")

        console.log(item, "asdasd")

        return {
          ...item,
          toggleSelected: !item.toggleSelected
        };
      });

      setData(updatedData);
    } else {
      setData(response.data.data);
    }


    setTotalRows(response.data.total);
    setColumns(eval(response.data.gridColumns))
    setkeyCounter(Math.round());
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchLeaseData(page);
  };

  function DownloadFile() {
    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url + '/close-deal/fetch-deal-details?' + prm + '&export=true'}`,
      data: {}
    }).then(function (response) {
      window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response.data}`;
    });

  }



  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    let pageCnt = page ? page : 0;
    formConfig["page"] = pageCnt;
    formConfig["per_page"] = perPage;
    if (typeof expiry_report != "undefined") {
      formConfig['expiry_report'] = 'true';
    }
    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    console.log(prm, "prm");

    const response = await axios.get(
      `${fetchUrl}` + prm
    );


    // const response = response.data.data.map(item => {
    //   if (row.id !== item.id) {
    //     return item;
    //   }

    //   return {
    //     ...item,
    //     toggleSelected: !item.toggleSelected
    //   };
    // });

    //setData(updatedData);

    //`${apiUrl.apiUrl.url}/lease-report/get-all-leases?asset=${asset}&brand=${brand}&page=${page}&per_page=${newPerPage}&delay=1`
    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchLeaseData(1);
  }, []);

  const handleRowClicked = row => {
    console.log(row, "row");
    const updatedData = data.map(item => {
      if (row.id !== item.id) {
        return item;
      }

      return {
        ...item,
        toggleSelected: !item.toggleSelected
      };
    });

    setData(updatedData);
  };

  function getCssClass(value) {
    if (value > 5000) return "high";
    else if (value > 500) return "medium";
    return "low";
  }

  // subHeaderComponent={subHeaderComponentMemo}
  return (
    <>
      <div className="tableContainer revenueTable">
        <DataTable
          key={keyCounter}
          
          columns={columns}
          //direction={auto}
          data={data}
          customStyles={datatableOptions.datatableOptions.customStyle}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          onChangePage={handlePageChange}
          //onRowClicked={handleRowClicked}

          //conditionalRowStyles={conditionalRowStyles}
          paginationComponentOptions={
            datatableOptions.datatableOptions.paginationOptions
          }
        />
      </div>
    </>
  );
};
export default RevenueTable;
